import React, { useCallback } from 'react';
import { SmBadge } from '@smiles/smiles-react-design-system';

import useModal from '@/hooks/useModal';
import useApi from '@/hooks/useApi';
import { IEventsTag } from '@/hooks/useVitrineTagging/types';
import { useVitrineTagging } from '@/hooks/useVitrineTagging';

import {
  TRecommendation,
  TRules,
} from '@/services/requests/Recommendation/types/template1';
import { TResponseTerms } from '@/services/requests/Liferay/types';
import { getTerms } from '@/services/requests/Liferay';

import { isHttpLink } from '@/helpers/StringHelper/isHttpLink';

type TProps = {
  rules: TRules;
  layout?: string;
  title: string;
  events_tag?: TRecommendation['events_tag'];
};

export const Rules = React.memo(
  ({ rules, layout, title, events_tag }: TProps) => {
    const modal = useModal();
    const { ApiLiferay } = useApi();

    const { triggerSelectContentClick } = useVitrineTagging({
      title,
      events_tag: events_tag as IEventsTag,
      cards: [],
    });

    const getData = async () => {
      const data: TResponseTerms | undefined = await getTerms(
        ApiLiferay,
        rules.content_key,
      );
      if (data) {
        modal.setContent(data.title, data.content);
      }
    };

    const handlerOpenModalButton = useCallback(() => {
      modal.setContent('Carregando...', '');
      modal.setShow(true);
      getData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlerHttpLink = () => {
      window.location.href = rules.content_key;
    };

    const checkContentKey = () => {
      triggerSelectContentClick({
        type: 'button',
        label: rules.label,
      });

      return isHttpLink(rules.content_key)
        ? handlerHttpLink()
        : handlerOpenModalButton();
    };

    return (
      <>
        {layout === '6' ? (
          <div className="vitrine-template1__rules__badge">
            <SmBadge text={rules.label} variant="neutral" />
          </div>
        ) : (
          <button
            className="vitrine-template1__rules"
            type="button"
            data-toggle="modal"
            data-target="#modalVitrine1"
            onClick={() => checkContentKey()}
          >
            {rules.label}
          </button>
        )}
      </>
    );
  },
);
